import { render } from "./FamilyIncomeBenefitAnalysis.vue?vue&type=template&id=b39f1d10&scoped=true"
import script from "./FamilyIncomeBenefitAnalysis.vue?vue&type=script&lang=js"
export * from "./FamilyIncomeBenefitAnalysis.vue?vue&type=script&lang=js"

import "./FamilyIncomeBenefitAnalysis.vue?vue&type=style&index=0&id=b39f1d10&lang=css"
import "./FamilyIncomeBenefitAnalysis.vue?vue&type=style&index=1&id=b39f1d10&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\ProtectionGuruVue\\client-app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b39f1d10"]])

export default __exports__